import { gql } from '@apollo/client';

export interface VerificationCodeEntry {
  type: string;
  code: string | null;
  ttlSeconds: number | null;
}

export interface LoginSessionEntry {
  source: string;
  key: string;
  endType: string | null;
  deviceId: string | null;
  loginTime: string | null;
  isActive: boolean | null;
  rawValue: string | null;
}

export interface AccountLoginSessions {
  found: boolean;
  accountId: number | null;
  name: string | null;
  role: string | null;
  tokenInvalidBefore: string | null;
  sessions: LoginSessionEntry[];
}

export interface RedisEntry {
  key: string;
  exists: boolean;
  value: string | null;
  ttlSeconds: number | null;
}

export const SUPPORT_TOOL_QUERY_VERIFICATION_CODES = gql`
  query SupportToolQueryVerificationCodes($countryCode: Int!, $phone: String!) {
    supportToolQueryVerificationCodes(countryCode: $countryCode, phone: $phone) {
      type
      code
      ttlSeconds
    }
  }
`;

export const SUPPORT_TOOL_QUERY_ACCOUNT_LOGIN_SESSIONS = gql`
  query SupportToolQueryAccountLoginSessions($countryCode: Int!, $phone: String!) {
    supportToolQueryAccountLoginSessions(countryCode: $countryCode, phone: $phone) {
      found
      accountId
      name
      role
      tokenInvalidBefore
      sessions {
        source
        key
        endType
        deviceId
        loginTime
        isActive
        rawValue
      }
    }
  }
`;

export const SUPPORT_TOOL_QUERY_REDIS_VALUE = gql`
  query SupportToolQueryRedisValue($key: String!) {
    supportToolQueryRedisValue(key: $key) {
      key
      exists
      value
      ttlSeconds
    }
  }
`;

export const SUPPORT_TOOL_DELETE_REDIS_KEY = gql`
  mutation SupportToolDeleteRedisKey($key: String!) {
    supportToolDeleteRedisKey(key: $key)
  }
`;
